import {Avatar} from 'antd'
import getLinkToDetail from 'helpers/getLinkToDetail'
import getTitle from 'helpers/getTitle'
import _ from 'lodash'
import Translate from 'modules/local/Translate'
import React from 'react'
import {IoPerson} from 'react-icons/io5'
import {Link} from 'react-router-dom'
import {formatDate} from "../../../helpers/datetimeHelpers";

export const renderHomeAsk = (item, index) => {
    const ask = _.get(item, 'content')

    return (
        <Translate key={index}>
            {(t) => (
                <div className="flex items-center gap-2 md:gap-3">
                    <Avatar
                        src={_.get(ask, 'creator.avatar')}
                        size={40}
                        icon={<IoPerson className="text-color-500"/>}
                        className="flex flex-center background-200"
                    />
                    <div className="flex flex-col flex-1 truncate">
                        <div className="flex items-baseline">
                            <div className="flex items-baseline flex-1 gap-1 italic leading-tight">
                                <Link
                                    to={getLinkToDetail(_.get(ask, 'creator'))}
                                    className="text-xs font-semibold text-color-300 max-lines-1 no-underline">
                                    {getTitle(_.get(ask, 'creator'))}
                                </Link>
                                <span className="text-2xs text-color-400 whitespace-no-wrap">
                                    {t('asked')}
                                </span>
                            </div>
                            <span className="ml-3 text-2xs text-color-400 italic tracking-wide">
                                {formatDate(_.get(item, 'created'), 'DD/MM/YY')}
                            </span>
                        </div>
                        <Link
                            to={getLinkToDetail(ask)}
                            className="font-semibold text-sm text-color-000 no-underline truncate">
                            {_.get(ask, 'title')}
                        </Link>
                    </div>
                </div>
            )}
        </Translate>
    )
}
